(() => {
  if (window.HolyDesktopNavigationReady) return;
  window.HolyDesktopNavigationReady = true;

  const closeSearch = details => {
    if (!details) return;
    details.open = false;
    const section = details.closest('.section-header-navigation');
    section?.classList.remove('sticky-search-menu-open');
    if (section) section.style.zIndex = '';
    details.querySelector('summary[data-search-menu]')?.setAttribute('aria-expanded', 'false');
  };

  document.addEventListener('click', event => {
    const navSummary = event.target.closest?.('.hs-desktop-navigation .hs-desktop-nav-group > summary');
    if (navSummary) {
      const nav = navSummary.closest('.hs-desktop-navigation');
      nav?.querySelectorAll('.hs-desktop-nav-group[open]').forEach(group => {
        if (group !== navSummary.parentElement) group.open = false;
      });
    }

    const trigger = event.target.closest?.('summary[data-search-menu-sticky-form]');
    if (trigger && window.matchMedia('(min-width:1025px)').matches) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const details = trigger.closest('details');
      const willOpen = !details.open;
      document.querySelectorAll('.header-navigation details.search_details[open]').forEach(item => {
        if (item !== details) closeSearch(item);
      });
      if (!willOpen) {
        closeSearch(details);
        return;
      }
      details.open = true;
      trigger.setAttribute('aria-expanded', 'true');
      const section = trigger.closest('.section-header-navigation');
      section?.classList.add('sticky-search-menu-open');
      if (section) section.style.zIndex = '101';
      requestAnimationFrame(() => details.querySelector('input[type="search"]')?.focus());
      return;
    }

    const closeButton = event.target.closest?.('.header-navigation .header-search-close');
    if (closeButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const details = closeButton.closest('details');
      closeSearch(details);
      details?.querySelector('summary[data-search-menu]')?.focus();
      return;
    }

    document.querySelectorAll('.header-navigation details.search_details[open]').forEach(details => {
      if (!details.contains(event.target)) closeSearch(details);
    });
  }, true);

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const details = document.querySelector('.header-navigation details.search_details[open]');
    if (!details) return;
    closeSearch(details);
    details.querySelector('summary[data-search-menu]')?.focus();
  });
})();
